export default class PralniStrojObj {
    ratings = [
        // 95  60  40  30
        [1.04109589, 0.588714938, 0.254076973, 0.161121983], //A+++ 2015 20%
        [1.01369863, 0.574429224, 0.243287671, 0.15543379], //A+++ 2015
        [0.936986301, 0.529843444, 0.228669276, 0.145009785], //A++ 2015
        [1.1424, 0.646, 0.2788, 0.1768], //A+++
        [1.344, 0.76, 0.328, 0.208], //A++
        [1.50, 0.85, 0.36, 0.23], //A+
        [1.68, 0.95, 0.41, 0.26], //A
        [2.03, 1.15, 0.49, 0.32], //B
        [2.38, 1.35, 0.58, 0.37], //C
        [2.73, 1.55, 0.66, 0.43], //D
        [3.09, 1.75, 0.75, 0.48], //E
        [3.44, 1.95, 0.83, 0.54], //F
    ];

    strings_ratings = [
        "A+++ (-20%, po 2015)",
        "A+++ (po 2015)",
        "A++ (po 2015)",
        "A+++ (po 2005)",
        "A++ (po 2005)",
        "A+ (po 2005)",
        "A (po 2005)",
        "B (2001-2004)",
        "C (1999-2000)",
        "D (1997-1998)",
        "E (1995-1996)",
        "F (1993 - 1994)",
    ];

    static curr_use;
    static new_use
    static savings;
    static curr_price;
    static new_price;

    ukrep1;
    ukrep1_savings;
    new_rating;

    ukrep2;
    ukrep2_savings;

    ukrep3;
    ukrep3_savings;

    ukrep4;
    ukrep4_savings;

    ukrep5;
    ukrep5_savings;

    constructor(rating, teden, vikend) {
        this.rating = rating;
        this.teden = teden;
        this.vikend = vikend;
        this.st_select = 2;
        this.short = "PS";
        this.st_ukrepov = 0;
        this.name = "Pralni stroj";

        this.my_rating = this.ratings[this.rating - 1];

        for(var i = 0; i < teden.length; i++) {
            this.curr_use += (teden[i] * this.my_rating[i]);
        }

        for(i = 0; i < vikend.length; i++) {
            this.curr_use += (vikend[i] * this.my_rating[i]); // ceneje za vikende??
        }

        this.detail_string = this.strings_ratings[this.rating - 1];
    }
}